import React from 'react';
import { Footer } from '../Common/Footer';
import { Link } from 'react-router-dom';
import { DashboardHeader } from '../Common/DashboardHeader';
import Request from '../../Models/Request';
import SimpleReactValidator from 'simple-react-validator';
import axios from 'axios';
import { Header } from '../Common';
import { SideBar } from '../Common/SideBar';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';
import {Spinner } from 'reactstrap';
class RequestDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: false,
            modal: false,
            categories: [],
            subCategories: [],
            category: '',
            sub_cat: '',
            request: '',
            requestAll: [],
            response_content: '',
            seller: '',
            date: '',
            budget: '',
            count: '',
            existing: [],
            visible: false,
            body: '',
            ready: 0
        };
        SimpleReactValidator.addLocale('klingon', {
            integer: '数字を入れてください.',
            max: ':attribute :max 文字以下にしてください .',
            required: ' :attribute を必須です.',
            min: ':attribute :min 文字以上にしてください .',
        });
        this.validator = new SimpleReactValidator({
            locale: 'klingon',
        })
        this.getDetails();
        // console.log(this.props.location.state.id)
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        setTimeout(
            function() {
                this.setState({ready: 1});
            }
            .bind(this),
            1000
        );
    }
    getDetails(){
        Request.getRequestDetail(this.props.location.state.id, this.props.location.state.user).then(res => {
            if (res.data.payload != null) {
                this.setState({ request: res.data.payload })
                this.setState({ requestAll: res.data.requestall })
                this.setState({ count: res.data.count })
                this.setState({ existing: res.data.existing_response })
                this.setState({ body: res.data.payload.content })
            }
        })
    }
    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handleSubmit(e) {
        document.getElementById("res_entry").disabled = true;
        e.preventDefault();
        if (this.validator.allValid()) {
            let a = this.state.request.budget_range.split('~')
            console.log(a)
            let i = parseInt(a[a.length - 1])
            console.log(i)
            let x = parseInt(a[a.length - 2])
            console.log(this.state.budget)
            if (this.state.budget >= x && this.state.budget <= i) {
                this.state.budget = this.state.budget;
            } else {
                alert(`※ 金額はから設定することができます ${this.state.request.budget_range} 円.`)
                return
            }
            var logged_user = JSON.parse(window.localStorage.getItem('info'));
            if (this.state.response_content == '' || this.state.response_content == null) {
                alert("サービス内容を入れてください");
                return;
            } else if (this.state.budget == '' || this.state.budget == null) {
                alert("金額を入れてください");
                return;
            } else if (this.state.date == '' || this.state.date == null) {
                alert("日付を入れてください");
                return;
            }
            let data = {
                'request_id': this.state.request.id,
                'seller_id': logged_user.id,
                'content': this.state.response_content,
                'estimated_price': this.state.budget,
                'estimated_deadline': this.state.date,
            }
            Request.saveRequestDetail(data).then(res => {
                if (res.data.status === 200) {
                    alert('入力情報を送信しました')
                    console.log(res.data)
                    if (res.data.path === 'TRANSACTION') {
                        window.location.href = '/seller-estimate'
                    } else {
                        window.location.href = '/request-home'
                    }
                }
            })
                .catch(
                    console.log('asd')
                )
        } else {
            document.getElementById("res_entry").disabled = false;
            this.validator.showMessages();
        }
    }

    validation() {
        if (this.validator.allValid()) {
            let a = this.state.request.budget_range.split('~')
            let i = parseInt(a[a.length - 1])
            let x = parseInt(a[a.length - 2])
            if (this.state.budget >= x && this.state.budget <= i) {
                this.setState({ budget: this.state.budget })
            } else {
                this.setState({ budget: '' })
                return
            }
            console.log(this.state.budget)
            this.setState({
                response_content: this.state.response_content,
                date: this.state.date,
            })
            this.toggle();
        } else {
            this.validator.showMessages();
        }
    }

    errorMessage() {
        if (this.state.request.length === 0) {
            return;
        } else {
            let a = this.state.request.budget_range.split('~')
            let i = parseInt(a[a.length - 1])
            let x = parseInt(a[a.length - 2])
            if (this.state.budget < x || this.state.budget > i) {
                return (
                    <div style={{ color: 'red', fontSize: '12px' }}>
                        <span>※ 金額はから設定することができます {this.state.request.budget_range} 円.</span>
                    </div>
                )
            }
        }
    }

    productsTitle() {
        if (this.state.request.product_id) {
            return (
                <Link to={{
                    pathname: `/categories-details/${this.state.request.product_id}`,
                    state: { id: this.state.request.product_id }
                }} className="col-md-12">
                    {this.state.request.pro_title}
                </Link>
            )
        } else {
            return (
                <div className=""></div>
            )
        }
    }

    confirmation() {
        return (
            <div>
                <Button type="submit" onClick={this.validation.bind(this)} style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1" }} >確認する</Button>
                <Modal isOpen={this.state.modal} toggle={this.toggle.bind(this)} className="modal-lg">
                    <ModalHeader toggle={this.toggle.bind(this)}></ModalHeader>
                    <ModalBody>
                        <div className="">
                            <div style={{ height: "auto" }}>
                                <div className="row  px-3">
                                    <div className="card mb-2 pages_contents" style={{ width: "100%", backgroundColor: '#f4f2f0' }}>
                                        <div className="row card-body " style={{ border: '0px solid' }}>
                                            <div className="col-md-2 small-hidden" style={{ textAlign: "center" }}>
                                                <img className="card-img-top small-hidden" style={{ borderRadius: "50%", height: "80px", width: '80px', objectFit: 'cover' }} src={this.state.request.img} alt=""></img>&nbsp;&nbsp;
                                            </div>
                                            <div className="col-md-10 ">
                                                <Link to={{ pathname: `/buyer-my-profile-view/users/${this.state.request.buyer_id}`, state: { id: this.state.request.buyer_id } }} className="row">
                                                    <div className="col-md-12"><b>{this.state.request.buyer_name}</b></div>
                                                </Link>
                                                <br />
                                                <div className="row">
                                                    <div className="col-md-3">依頼日</div>
                                                    <div className="col-md-1 small-hidden">:</div>
                                                    <div className="col-md-8"><b>{this.state.request.created_at}</b></div>
                                                </div>
                                                <br />
                                                <div className="row">
                                                    <div className="col-md-3">見積り提案期限</div>
                                                    <div className="col-md-1 small-hidden">:</div>
                                                    <div className="col-md-8"><b>{this.state.request.application_date}</b></div>
                                                </div>
                                                <br />
                                                <div className="row">
                                                    <div className="col-md-3">見積り予算</div>
                                                    <div className="col-md-1 small-hidden">:</div>
                                                    <div className="col-md-8"><b>{this.state.request.budget_range} 円</b></div>
                                                </div>
                                                <br />
                                                <div className="row">
                                                    <div className="col-md-3">タイトル</div>
                                                    <div className="col-md-1 small-hidden">:</div>
                                                    <div className="col-md-8"><b>{this.state.request.title}</b></div>
                                                </div>
                                            </div>
                                            <div className=" row card-body">
                                                <div className="col-md-2"></div>
                                                <div className="col-md-10 card-text">
                                                    {this.state.body.split('\n').map(function (item, key) {
                                                        return (
                                                            <span key={key}>
                                                                {item}
                                                                <br />
                                                            </span>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card mb-2 pages_contents" style={{ width: "100%", height: "auto" }}>
                                        <div >
                                            <div className="card-body" style={{ width: "100%", backgroundColor: '#f4f2f0' }}>
                                                <div className="row ml-3" >
                                                    <div className="col-md-10">
                                                        {/* <div>
                                                            <h4>{this.state.budget} 円</h4>
                                                        </div> */}
                                                        <div className="row">
                                                            <div className="">完成予定日 :</div>
                                                            {/* <div className="col-md-1">:</div> */}
                                                            <div className="col-md-10"><b>{this.state.date}</b></div>
                                                        </div>
                                                        <br />
                                                        <div className="row">
                                                            <div className="">見積り金額 :</div>
                                                            {/* <div className="col-md-1">:</div> */}
                                                            <div className="col-md-10"><b>{this.state.budget} 円</b></div>
                                                        </div>
                                                        <br />
                                                        {/* <div>
                                                            <div>
                                                                完成予定日
                                                                </div>
                                                            <div>
                                                                {this.state.date}
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                    <div className="col-md-10">
                                                        <div className="row">
                                                            {/* <div className="col-md-2">
                                                                <img style={{ borderRadius: "50%", height: "60px", objectFit: 'cover' }} src={this.state.request.img} alt=""></img>&nbsp;&nbsp;
                                                            </div>
                                                            <div className="col-md-10">
                                                                <div className="ml-3 mt-3">{this.state.request.buyer_name}</div>
                                                            </div> */}
                                                        </div>
                                                        <div className="row">
                                                            <div className="">見積り詳細 :</div>
                                                            <div className="col-md-10">
                                                                <div className="">
                                                                    {this.state.response_content.split('\n').map(function (item, key) {
                                                                        return (
                                                                            <span key={key}>
                                                                                {item}
                                                                                <br />
                                                                            </span>
                                                                        )
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggle.bind(this)}>修正する</Button>{' '}
                        <Button id="res_entry" style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1" }} onClick={this.handleSubmit.bind(this)} >送信する</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }

    render() {
        if (this.state.ready === 1) {
        return (
            <div>
                <Header />
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="col-md-12 tr_blank_medium mt-5 small-hidden"></div>
                <div className="container">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-4 input_name small-hidden">
                                <SideBar />
                            </div>
                            <div className="col-md-8">
                                <div className="mt-5 mb-3 input_name big_font guide_text pages_headers" style={{ width: '100%' }}>
                                    詳細
                                </div>
                                <div className=" pages_contents">
                                    <div style={{ height: "auto" }}>
                                        <div className="row  px-3">
                                            <div className="card" style={{ width: "100%", backgroundColor: '#f4f2f0' }}>
                                                <div className="row card-body">
                                                    <div className="col-md-2 small-hidden" style={{ textAlign: "center" }}>
                                                        <img className="card-img-top small-hidden" style={{ borderRadius: "50%", height: "60px", width: '60px', objectFit: 'cover' }} src={this.state.request.img} alt=""></img>&nbsp;&nbsp;
                                                    </div>
                                                    <div className="col-md-10 ">
                                                        <Link to={{ pathname: `/buyer-my-profile-view/users/${this.state.request.buyer_id}`, state: { id: this.state.request.buyer_id } }} className="row">
                                                            {/* <div className="col-md-3">相談依頼日</div>
                                                            <div className="col-md-1">:</div> */}
                                                            <div className="col-md-12"><b>{this.state.request.buyer_name}</b></div>
                                                        </Link>
                                                        <div className="small-hidden">
                                                            <br />
                                                        </div>
                                                        <div className="row">
                                                            {this.productsTitle()}
                                                        </div>
                                                        <br />
                                                        <div className="row">
                                                            <div className="col-md-3">依頼日</div>
                                                            <div className="col-md-1 small-hidden">:</div>
                                                            <div className="col-md-8"><b>{this.state.request.created_at}</b></div>
                                                        </div>
                                                        <br />
                                                        <div className="row">
                                                            <div className="col-md-3">見積り提案期限</div>
                                                            <div className="col-md-1 small-hidden">:</div>
                                                            <div className="col-md-8"><b>{this.state.request.application_date}</b></div>
                                                        </div>
                                                        <br />
                                                        <div className="row">
                                                            <div className="col-md-3">見積り予算</div>
                                                            <div className="col-md-1 small-hidden">:</div>
                                                            <div className="col-md-8"><b>{this.state.request.budget_range} 円</b></div>
                                                        </div>
                                                        <br />
                                                        <div className="row">
                                                            <div className="col-md-3">タイトル</div>
                                                            <div className="col-md-1 small-hidden">:</div>
                                                            <div className="col-md-8"><b>{this.state.request.title}</b></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className=" row card-body">
                                                    <div className="col-md-2"></div>
                                                    <div className="col-md-10 card-text">
                                                        {/* {this.state.request.content}<br /> */}
                                                        {this.state.body.split('\n').map(function (item, key) {
                                                            return (
                                                                <span key={key}>
                                                                    {item}
                                                                    <br />
                                                                </span>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                            &nbsp;
                                            {(() => {
                                                if (this.state.count !== 0) {
                                                    return (
                                                        <div className="card" style={{ width: "100%" }}>
                                                            {this.state.existing.map(group =>
                                                                <div className="card-body" style={{ width: "100%", backgroundColor: '#f4f2f0' }}>
                                                                    <div className="row mb-1">
                                                                        <div className="col-md-2"></div>
                                                                        <div className="col-md-10 mb-1">
                                                                            見積価格: {group.estimated_price}
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-1">
                                                                        <div className="col-md-2"></div>
                                                                        <div className="col-md-10">
                                                                            完成予定日: {group.estimated_deadline.substring(0, 11)}
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-1" >
                                                                        <div className="col-md-2"></div>
                                                                        <div className="col-md-10 mb-1"> 見積り詳細: &nbsp;
                                                                            {group.content.split('\n').map(function (item, key) {
                                                                            return (
                                                                                <span key={key}>
                                                                                    {item}
                                                                                    <br />
                                                                                </span>
                                                                            )
                                                                        })}
                                                                        </div>
                                                                    </div>
                                                                    <br />
                                                                </div>
                                                            )}
                                                        </div>
                                                    )
                                                }
                                            })()}
                                            &nbsp;
                                            {(() => {
                                                return (
                                                    <div className="card" style={{ width: "100%", backgroundColor: '#f4f2f0' }}>
                                                        <div className="card-body row">
                                                            <div className="col-md-2"></div>
                                                            <div className="col-md-8">
                                                                <div>見積り詳細</div>
                                                                <div style={{ padding: "" }}>
                                                                    <textarea style={{ width: "100%", height: "90px", borderRadius: "3px", borderColor: "#d0cfcf", border: '1px solid #ccc', padding: '10px' }} value={this.state.response_content} onChange={this.updateValue.bind(this, 'response_content')}></textarea>
                                                                    <span style={{ fontSize: '12px', color: 'red' }}>{this.validator.message('見積り詳細', this.state.response_content, 'required|max:1000')}</span>
                                                                </div>
                                                                <br />
                                                                <div>
                                                                    <span>見積価格（必須）:</span>&nbsp;
                                                                            <input type="number" style={{ padding: '5px' }} onChange={this.updateValue.bind(this, 'budget')} value={this.state.budget}></input><br />
                                                                    {this.errorMessage()}
                                                                    <span style={{ fontSize: '12px', color: 'red' }}>{this.validator.message('見積価格', this.state.budget, 'required')}</span>
                                                                    {/* <span style={{ fontSize: "12px" }}>※ 金額はから設定することができます {this.state.request.budget_range} 円.</span> */}
                                                                </div>
                                                                <div>&nbsp;</div>
                                                                <div>
                                                                    <span>完成予定日:</span>&nbsp;
                                                                            <input style={{ border: "1px solid #d0cfcf", borderRadius: "3px" }} type="date" value={this.state.date} onChange={this.updateValue.bind(this, 'date')}></input><br />
                                                                    <span style={{ fontSize: '12px', color: 'red' }}>{this.validator.message('完成予定日', this.state.date, 'required')}</span>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-2"></div>
                                                        </div>
                                                        <div className="card-body" style={{ textAlign: "center" }}>
                                                            {this.confirmation()}
                                                        </div>
                                                    </div>
                                                )
                                            })()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div >
        )
        } else {
            return (
                <div className="container-fluid">
                    <div className="container">
                        <div className="" style={{ height: '380px' }}></div>
                        <div className="text-center mt-3">
                            <Spinner color="primary" size="150" />
                        </div>
                    </div>
                </div>
            )
        }
    }
}
export { RequestDetails }